import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";

var _Icon;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/Icon';
import messages from './messages';
import { FiltersButtonWrapper, FiltersButton } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";

function FilterButton(_ref) {
  var isOpen = _ref.isOpen,
      onButtonCLick = _ref.onButtonCLick;
  return /*#__PURE__*/_jsx(FiltersButtonWrapper, {}, void 0, /*#__PURE__*/_jsx(FiltersButton, {
    "data-active": isOpen,
    onClick: onButtonCLick
  }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
    name: "filter"
  })), /*#__PURE__*/_jsx2(FormattedMessage, _objectSpread({}, messages.filterButton))));
}

export default /*#__PURE__*/memo(FilterButton);